import Architer from 'assets/icons/architer.svg';
import Lif from 'assets/icons/lif.svg';
import Notes from 'assets/icons/notes.svg';
import Figma from 'assets/icons/figma.svg';
import Analytics from 'assets/icons/analytics.svg';
import Bugs from 'assets/icons/bugs.svg';
import Share from 'assets/icons/share.svg';

import SysAnalysisIso from 'assets/illustrations/aboutUsIsometrics/SysAnalysisIso.svg';
import DevIso_1 from 'assets/illustrations/aboutUsIsometrics/DevIso_1.svg';
import DevIso_2 from 'assets/illustrations/isometrics/5.png';
import DevIso_3 from 'assets/illustrations//isometrics/2.png';
import Iso1C from 'assets/illustrations/isometrics/1.png';
import UiUxIso from 'assets/illustrations/isometrics/uxUi.png';
import QAIso from 'assets/illustrations/aboutUsIsometrics/QAIso.svg';
import DiscoveryIso from 'assets/illustrations/aboutUsIsometrics/DiscoveryIso.png';
import DevOpsIso from 'assets/illustrations/aboutUsIsometrics/DevOpsIso.svg';

export const aboutUsTechExpertData = {
  title: (
    <>
      Области технической
      <br /> экспертизы ASTON
    </>
  ),

  cardsData: [
    {
      title: 'Системный анализ',
      tabIcon: Architer,
      content:
        'Аналитики выявят и проанализируют требования к ИТ-решению, что позволит повысить качество вашего ПО',
      descriptionIcon: SysAnalysisIso,
    },
    {
      title: 'Разработка ПО',
      tabIcon: Lif,
      contentSliderCardsData: [
        {
          title: 'Разработка ПО',
          subTitle: 'Расширение ИТ-команды',
          content:
            'ASTON подберёт технических экспертов с необходимыми навыками, чтобы усилить ваш проект',
          link: '/services/software-team-staff-augmentation',
          descriptionIcon: DevIso_1,
        },
        {
          title: 'Разработка ПО',
          subTitle: 'Мобильная разработка',
          content:
            'Команда ASTON разработает высококачественное мобильное приложение любой сложности',
          descriptionIcon: DevIso_2,
        },
        {
          title: 'Разработка ПО',
          subTitle: 'Веб-разработка',
          content: 'ASTON создаёт веб-сайты и приложения, которые эффективно решают бизнес-задачи',
          descriptionIcon: DevIso_3,
        },
      ],
    },
    {
      title: '1С-разработка',
      link: '/1C',
      tabIcon: Notes,
      content:
        'Внедряем прикладные программные решения на платформе 1С, применяем типовые конфигурации, обеспечиваем интеграцию с системами',
      descriptionIcon: Iso1C,
    },
    {
      title: 'Дизайн интерфейсов (UI/UX\u2011дизайн)',
      tabIcon: Figma,
      content:
        'Команда дизайнеров интерфейсов (UI/UX) ASTON готова разработать внешний вид любой сложности под специфику вашего бизнеса',
      descriptionIcon: UiUxIso,
    },
    {
      title: 'Тестирование',
      tabIcon: Analytics,
      content:
        'Команда контроля качества ASTON поможет вам поддерживать и повышать качество ИТ‑решений',
      descriptionIcon: QAIso,
    },
    {
      title: 'Этап исследования (Дискавери)',
      tabIcon: Bugs,
      content:
        'Наши технические специалисты разработают четкий план, содержащий все необходимые требования к продукту',
      descriptionIcon: DiscoveryIso,
    },
    {
      title: 'Услуги инженеров по автоматизации разработки',
      tabIcon: Share,
      content:
        'Высококвалифицированные специалисты (DevOps) помогут результативно объединить ваши деловые процессы и разработку ПО',
      descriptionIcon: DevOpsIso,
    },
  ],
};
